module.exports = __webpack_public_path__ + "img/snapdate.pl.f219f30b.png";